import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { DimonaStatus } from './dimona-status.interface';
import { DimonaStatusService } from './dimona-status.service';

const service = new DimonaStatusService();

export interface DimonaStatusState {
   dimonaStatuses: Array<DimonaStatus>;
}

const DimonaStatusStore: Module<DimonaStatusState, StoreState> = {
   namespaced: true,
   state: {
      dimonaStatuses: [],
   },
   getters: {},
   mutations: {
      SET_DIMONA_STATUSES(state, dimonaStatuses: Array<DimonaStatus>) {
         state.dimonaStatuses = dimonaStatuses;
      },
   },
   actions: {
      async getDimonaStatuses(context) {
         const dimonaStatuses = await service.getDimonaStatuses();
         context.commit('SET_DIMONA_STATUSES', dimonaStatuses);
         return dimonaStatuses;
      },
   },
};

export default DimonaStatusStore;
